import { useTranslation } from "@/hooks/useTranslation"
import { HeaderPage } from "@/organisms/HeaderPage"
import { PageTemplate } from "@/templates/PageTemplate"

import { DraggableWorkflowTable } from "../../organisms/AutomatedActionsTab/DraggableAutomatedActions"
import { AutomatedActionsPageComponent } from "./AutomatedActionsPage.types"

export const AutomatedActionsPage: AutomatedActionsPageComponent = (props) => {
  const { t } = useTranslation()

  return (
    <PageTemplate
      full
      header={
        <HeaderPage
          titleTranslationKey={t("settings.automatedActions.title")}
        />
      }
    >
      <DraggableWorkflowTable {...props} />
    </PageTemplate>
  )
}
